import React from 'react'
import ComparisonCard from './ComparisonCard'
import { ToDRebatesProps } from './modules'


const ToDRebates = ({items}: ToDRebatesProps) => {
    return (
        <div className="flex-1">
            <div className="text-xs font-medium text-gray-700 mb-2">ToD Zone-wise Rebates</div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 ">
                {items.map((item, index) => (
                    <ComparisonCard key={`tod-${index}`} {...item} />
                ))}
            </div>
        </div>
    )
}

export default ToDRebates